import { render, staticRenderFns } from "./ModalVillageHistory.vue?vue&type=template&id=1798b8f1"
import script from "./ModalVillageHistory.vue?vue&type=script&lang=ts"
export * from "./ModalVillageHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports